import { Checkbox } from '@src/common/components/Checkbox';
import type { Field } from '@src/permitField/PermitFields';
import type { Control } from 'react-hook-form';
import { Controller } from 'react-hook-form';

export type SectionField = {
  field: typeof Field;
  label: string;
};

type Props = {
  sectionFields: SectionField[];
  control: Control;
};
export const PermitTypeSectionCheckboxList = (props: Props) => {
  return props.sectionFields.map((section: SectionField) => (
    <Controller
      key={section.field.fieldName}
      name={section.field.fieldName}
      control={props.control}
      render={({ field }) => (
        <Checkbox
          label={section.label}
          onChange={(e) => {
            field.onChange(e.target.checked);
          }}
          checked={!!field.value}
          sx={{ my: -1 }}
        ></Checkbox>
      )}
    />
  ));
};
